export const POSITION_LEVEL_TIERS = ['管理层', '员工层', '操作层', '见习层', '/'];

export const POSITION_LEVEL_ATTRIBUTES = ['职能', '项目', '职能/项目'];

export const POSITION_NAME_DISPLAY_MODES = [
  { value: 'position_plus_level', label: '按岗位+职级显示' },
  { value: 'position_only', label: '按岗位展示' }
];

export const ORG_TYPES = [
  { value: 1, label: '集团' },
  { value: 2, label: '中心' },
  { value: 3, label: '项目/子部门' },
  { value: 4, label: '项目部门' }
];

export const ORG_REGION_OPTIONS = [
  { value: '成都地区', label: '成都地区' },
  { value: '内江地区', label: '内江地区' },
  { value: '巴中地区', label: '巴中地区' },
  { value: '云南地区', label: '云南地区' },
  { value: '阿坝州地区', label: '阿坝州地区' }
];

export const ORG_LEVEL_COLORS = {
  1: '#1677ff',
  2: '#722ed1',
  3: '#13c2c2',
  4: '#52c41a'
};

export const PROJECT_OPS_CENTER_CODE = '06';
export const PROJECT_OPS_CENTER_NAME = '品质运营中心';

export const BUSINESS_TYPES = ['保安', '餐饮', '健康', '科技', '物业', '其他'];

export const EMPLOYEE_TYPES = ['项目部', '总部', '外包', '实习', '其他'];

export const EMPLOYMENT_STATUS = [
  { value: 1, label: '在职' },
  { value: 2, label: '离职' }
];

export const PROBATION_STATUS = ['试用中', '已转正', '无试用期'];

export const RESIGN_TYPE_OPTIONS = [
  { value: '主动离职', label: '主动离职' },
  { value: '被动离职', label: '被动离职' }
];

export const EDUCATION_OPTIONS = ['博士', '硕士', '本科', '大专', '高中', '中专', '初中及以下'];

export const CONTRACT_TYPES = ['固定期限', '无固定期限', '以完成一定工作任务为期限', '劳务合同'];

export const ATTACHMENT_TYPES = [
  { value: 'photo', label: '员工照片' },
  { value: 'id_front', label: '身份证人像面' },
  { value: 'id_back', label: '身份证国徽面' },
  { value: 'diploma', label: '学历证书' },
  { value: 'degree', label: '学位证书' },
  { value: 'resignation_proof', label: '前公司离职证明' },
  { value: 'contract', label: '合同扫描件' },
  { value: 'other', label: '其他' }
];

export const PROCESS_STATUS = {
  draft: { label: '草稿', color: 'default' },
  pending: { label: '进行中', color: 'processing' },
  approved: { label: '已完成', color: 'success' },
  rejected: { label: '已驳回', color: 'error' },
  cancelled: { label: '已终止', color: 'default' }
};

export const ARCHIVE_STATUS = {
  ACTIVE: 1,
  RESIGNED: 2,
  PENDING_HIRE: 3,
  CANCELLED_HIRE: 4
};

export const ARCHIVE_STATUS_OPTIONS = [
  { value: 1, label: '在职档案' },
  { value: 2, label: '离职封存' }
];

export const ARCHIVE_CONFIRM_STATUS = {
  UNCONFIRMED: 0,
  CONFIRMING: 1,
  CONFIRMED: 2
};

export const ARCHIVE_CONFIRM_STATUS_OPTIONS = [
  { value: 0, label: '档案未确认' },
  { value: 1, label: '档案确认中' },
  { value: 2, label: '档案已确认' }
];

/** 档案确认角色在「确认中」状态下看到的标签 */
export const ARCHIVE_CONFIRM_PENDING_LABEL = '档案待确认';

export function resolveArchiveConfirmStatusTag(status, hasConfirmPerm) {
  const value = Number(status ?? ARCHIVE_CONFIRM_STATUS.CONFIRMED);
  if (value === ARCHIVE_CONFIRM_STATUS.CONFIRMING && hasConfirmPerm) {
    return { label: ARCHIVE_CONFIRM_PENDING_LABEL, color: 'error' };
  }
  const hit = ARCHIVE_CONFIRM_STATUS_OPTIONS.find((o) => o.value === value);
  const color = value === ARCHIVE_CONFIRM_STATUS.CONFIRMED
    ? 'success'
    : value === ARCHIVE_CONFIRM_STATUS.CONFIRMING
      ? 'processing'
      : 'warning';
  return { label: hit?.label || '-', color };
}

export const MARITAL_STATUS_OPTIONS = ['未婚', '已婚', '初婚', '再婚', '复婚', '丧偶', '离婚'].map((v) => ({ value: v, label: v }));

export const POLITICAL_STATUS_OPTIONS = [
  '中国共产党员', '中国共产党预备党员', '中国共产主义青年团团员', '群众'
].map((v) => ({ value: v, label: v }));

export const EMERGENCY_RELATION_OPTIONS = ['父母', '夫妻', '子女', '亲戚', '朋友', '其他'].map((v) => ({ value: v, label: v }));

export const STUDY_MODE_OPTIONS = ['统招全日制', '自考', '成人教育', '开放大学', '其他'].map((v) => ({ value: v, label: v }));

export const EDUCATION_LEVEL_OPTIONS = [
  { value: '11', label: '11 博士研究生' },
  { value: '14', label: '14 硕士研究生' },
  { value: '21', label: '21 大学本科' },
  { value: '31', label: '31 大学专科' },
  { value: '41', label: '41 中等专科' },
  { value: '44', label: '44 职业高中' },
  { value: '47', label: '47 技工学校' },
  { value: '61', label: '61 普通中学' },
  { value: '71', label: '71 初级中学' },
  { value: '81', label: '81 小学' },
  { value: '90', label: '90 其他' }
];

export const HIGH_EDUCATION_CODES = new Set(['11', '14', '21', '31']);
export const DEGREE_REQUIRED_CODES = new Set(['11', '14']);

export const ARCHIVE_DETAIL_TABS = [
  { key: 'info', label: '员工信息' },
  { key: 'contract', label: '合同协议' },
  { key: 'insurance', label: '保险信息' },
  { key: 'salary', label: '薪资绩效' },
  { key: 'changes', label: '人事异动' },
  { key: 'rewards', label: '奖惩记录' },
  { key: 'training', label: '培训经历' },
  { key: 'attachments', label: '附件' },
  { key: 'lifecycle', label: '变更记录' }
];

export const HR_PROCESS_PAGES = {
  '/hr/onboarding': { type: 'onboarding', title: '入职管理' },
  '/hr/regularization': { type: 'regularization', title: '转正管理' },
  '/hr/transfer': { type: 'transfer', title: '人员异动管理' },
  '/hr/resignation': { type: 'resignation', title: '离职管理' }
};

export const GENDER_OPTIONS = [
  { value: 1, label: '男' },
  { value: 2, label: '女' }
];

/** 中国 56 个民族（国标） */
export const CHINA_ETHNICITIES = [
  '汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族',
  '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族',
  '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族',
  '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族',
  '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族',
  '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'
];
